import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppiceHomeWirelessService } from 'src/app/services/appice-homewireless.service';
import { AppiceService } from 'src/app/services/appice.service';
import { CartService } from 'src/app/services/cart.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DepositAmountModalComponent } from '../deposit-amount/deposit-amount-modal.component';
import { PopoverComponent } from '../popover/popover.component';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';

@Component({
  selector: 'app-price-summary',
  templateUrl: './price-summary.component.html',
  styleUrls: ['./price-summary.component.scss'],
})
export class PriceSummaryComponent implements OnInit {
  @Input() cart: any;
  @Input() page: string;
  @Input() isAvailable: boolean;
  @Input() isPremiumPostpaidPlan: boolean;
  @Input() checkPremiumPrice: any;
  public promoCode: any;
  showPromoCard = false;
  showError: boolean;
  showSuccess: boolean = false;
  error: string;
  numberOfItemsInCart: any;
  popoverControl = false;
  promoCodeId: any;
  language: any;
  couponAlredyUsed: boolean;
  showOneTimePopOver: boolean = false;
  hideErrMsgOnRemovePromoCode: boolean = false;
  IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION = false;
  depositPopoverControl = false;
  showDepositPayment: boolean = false;
  constructor(
    private CS: CartService,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    public popoverController: PopoverController,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private appice: AppiceService,
    private UIS: UserInfoService,
    private appIceHomeWireless: AppiceHomeWirelessService,
    private modalController: ModalController,
    private appInitService: ApplicationInitializationService
  ) {}

  ngOnInit() {
    this.language =
      localStorage.getItem('language') &&
      localStorage.getItem('language').toLocaleLowerCase();
    this.showSuccess = false;
    if (
      this.cart &&
      this.cart.adjustments &&
      this.cart.adjustments.length > 0
    ) {
      const promoCode = localStorage.getItem('promoCode');
      this.promoCode = promoCode;
      this.showSuccess = true;
      this.promoCodeId = this.cart.adjustments[0].id;
      localStorage.setItem('promoCodeId', this.promoCodeId);
      this.cdr.detectChanges();
    }
    if (
      this.appInitService?.environmentConfig?.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION?.toLowerCase() ==
      'true'
    ) {
      this.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION = true;
    }
    if (this.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION) {
      this.SS.removePromoCodeOnCartOrderDelete.subscribe((res: any) => {
        if (res == true) {
          this.showError = true;
          this.showSuccess = false;
          this.promoCode = '';
          this.cdr.detectChanges();
        }
      });
    }
    console.log('this.cart:', this.cart);
    if (this.cart && this.cart?.items && this.cart?.items.length > 0) {
      const foundItem = this.cart?.items.find(
        (item) =>
          item?.commerceItemType === 'mobilePlanSku' &&
          item?.commerceItemCategory !== 'Visitor_line_plan'
      );
      console.log('foundItem:', foundItem);
      if (foundItem !== undefined) {
        this.showDepositPayment = true;
      } else {
        this.showDepositPayment = false;
      }
    }
    console.log('this.showDepositPayment:', this.showDepositPayment);
    this.cdr.detectChanges();
  }

  validateCoupon() {
    const payload = { id: this.promoCode };
    this.couponAlredyUsed = false;
    this.CS.validateCoupon(payload).subscribe(
      (res: any) => {
        if (res && res.valid == false) {
          this.showError = true;
          this.showSuccess = false;
          localStorage.setItem('promoCode', this.promoCode);
          //  this.promoCode = '';
          this.error =
            'The promo code you entered is invalid.Please try again.';
          //  this.promoCode = null;
          if (res.errorCode == 'usedCoupon') {
            this.couponAlredyUsed = true;
          }
          //ETWS-165
          this.appIceHomeWireless.hwPromoCodeEvent(
            'Home Wireless Shopping Cart Page',
            res.valid,
            this.error
          );
        }
        if (res && res.valid == true) {
          //ETWS-165
          this.appIceHomeWireless.hwPromoCodeEvent(
            'Home Wireless Shopping Cart Page',
            res.valid
          );
          this.CS.addPromoCode(payload).subscribe((res: any) => {
            this.showSuccess = true;
            this.showError = false;
            this.SS.refreshCart.next(true);
            if (this.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION) {
              if (this.cart.isCartContainsVisitorLine) {
                this.SS.refreshVisitorLineCartForPromoCode.next(true);
              }
            }
          });
        }
      },
      (e) => {
        // APPICE EVENT ON ERROR
        this.UIS.getUserInfo().subscribe((userInfo) => {
          this.appice.onError('Cart', 'PromoCode_Error', e, userInfo);
        });
        this.couponAlredyUsed = false;
        this.showError = true;
        this.showSuccess = false;
        this.promoCode = '';
        this.error = 'The promo code you entered is invalid.Please try again.';
        this.promoCode = null;
        if (e.error.errorCode == 'usedCoupon') {
          this.couponAlredyUsed = true;
        }
      }
    );
  }
  removePromoCode(id) {
    const payload = { id: id };
    this.CS.removePromoCode(payload).subscribe((res: any) => {
      this.showError = false;
      this.showSuccess = false;
      this.promoCode = '';
      localStorage.removeItem('promoCode');
      this.SS.refreshCart.next(true);
      if (this.IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION) {
        if (this.cart?.isCartContainsVisitorLine) {
          this.updateItemQuantityRemove();
          this.hideErrMsgOnRemovePromoCode = true;
        } else {
          this.hideErrMsgOnRemovePromoCode = false;
        }
      }
    });
  }
  updateItemQuantityRemove() {
    console.log(this.cart?.quantity);
    const payload = {
      productId: this.cart?.items[0]?.productId,
      skuId: this.cart?.skuId,
      selectedPaymentOptionId: '-1',
      quantity: 1,
      commerceItemId: this.cart?.items[0]?.commerceItemId,
    };
    this.CS.updateItemToShoppingCartOneByOne(payload).subscribe(
      (res: any) => {
        this.SS.refreshCart.next(true);
        this.SS.refreshVisitorLineCartForREmovePromoCode.next('remove');
        this.SS.refreshVisitorLineCartForPromoCode.next(false);
        // this.promoCode = false;// this.SS.refreshVisitorLineCartForPromoCode.next(true);
        // this.cdr.detectChanges();
      },
      (e: any) => {
        if (e && e.error) {
          if (
            e.error.errorDescription != null ||
            e.error.errorDescription != 'null' ||
            e.error.errorDescriptionAr != null ||
            e.error.errorDescriptionAr != 'null'
          ) {
            if (this.language == 'en') {
              this.UTS.error(e.error.errorDescription);
            } else {
              this.UTS.error(e.error.errorDescriptionAr);
            }
          } else {
            this.UTS.error(e.error.message);
          }
        }
      }
    );
  }
  showHidePromoCode() {
    this.showError = false;
    this.promoCode = '';
    this.error = '';
    this.showPromoCard = !this.showPromoCard;
  }

  callCartAgainAfterAddingAndRemovingPromoCode() {
    this.CS.getShoppingCart().subscribe(
      (response) => {
        this.cart = response;
        sessionStorage.setItem('shoppingCart', JSON.stringify(this.cart));
        this.numberOfItemsInCart = this.cart.numberOfItemsInCart
          ? this.cart.numberOfItemsInCart
          : 0;
      },
      (error) => {}
    );
  }
  getTotalPayNow() {
    return this.cart.totalPayNow;
  }

  getBundleItemPrice(items) {
    let price: any;
    if (items[0].paymentOptions) {
      price = items[0].paymentOptions.price;
      items[0].commerceItemsList.forEach((subItem) => {
        price = Number(price) + Number(subItem.paymentOptions.price);
      });
    }

    return price;
  }
  getTotalOneTimePrice() {
    let price: any;
    if (this.cart && this.cart.items && this.cart.items.length > 0) {
      price = this.cart.totalOneTime;

      this.cart.items.forEach((item: any) => {
        if (
          item.advancePayRequired &&
          item.advancePayment &&
          item.advancePayment > 0
        ) {
          price = Number(price) + Number(item.advancePayment);
        }
      });
    }
    return price;
  }
  getDepositPayment() {
    let price = 0;
    console.log('getDepositPayment this.cart.items:', this.cart.items);

    if (this.cart && this.cart?.items && this.cart?.items.length > 0) {
      this.cart.items.forEach((item: any) => {
        let advancePayment = item?.itemPriceInfo?.advancePayment ? item?.itemPriceInfo?.advancePayment : item?.advancePayment;
        let numAdvancePayment = Number(advancePayment); // Convert to number here

        if (numAdvancePayment == null || numAdvancePayment === undefined) {
          numAdvancePayment = 0; // Set to 0 if NaN or undefined
        }

        if (
          advancePayment &&
          advancePayment > 0 &&
          item?.commerceItemType === 'mobilePlanSku' &&
          item?.commerceItemCategory !== 'Visitor_line_plan'
        ) {
          price += numAdvancePayment;
        }
      });
    }

    console.log('getDepositPayment price:', price);
    console.log('this.cart.totalPayNow:', this.cart.totalPayNow);
    return price;
  }

  getTotalDeliveryCharges() {
    let totalDeliveryCharges: any = 0;

    if (this.cart && this.cart.items && this.cart.items.length > 0) {
      this.cart.items.forEach((item) => {
        if (
          item.selectedShippingMethod != undefined &&
          item.selectedShippingMethod.deliveryMethod != 'Normal'
        ) {
          if (item?.quantity > 1) {
            totalDeliveryCharges =
              Number(totalDeliveryCharges) +
              Number(item.selectedShippingMethod.price * item?.quantity);
          } else {
            totalDeliveryCharges =
              Number(totalDeliveryCharges) +
              Number(item.selectedShippingMethod.price);
          }
        }
      });
    }

    // if (totalDeliveryCharges != Number(0))
    sessionStorage.setItem('totalDeliveryCharges', totalDeliveryCharges);

    totalDeliveryCharges = sessionStorage.getItem('totalDeliveryCharges');
    return totalDeliveryCharges;
  }

  presentPopover(show) {
    this.popoverControl = show;
  }

  depositPopover(show) {
    this.depositPopoverControl = show;
  }

  // EWS:1017 Scenario 4A
  showDepositAmountPopup() {
    let planItem = this.cart.items.find((x) => x.isDepositAmountRequired);
    this.openBottomSheet(
      DepositAmountModalComponent,
      {
        name: planItem?.displayName,
        advancePaymentAmount: planItem?.advancePayment,
        totalAmount: this.cart?.advancePayment,
      },
      'verification-modal modal-fullscreen eand-radius-modal-desktop eand-partail-height-screen-bottom-50 eand-partail-height-screen-bottom-mobile-100'
    );
  }

  async openBottomSheet(
    component: any,
    data?: any,
    classes = 'verification-modal modal-fullscreen'
  ) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: classes,
    });
    return await modal.present();
  }
  presentPopoverOnTime(show: any) {
    this.showOneTimePopOver = show;
  }
}
